import React from 'react';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { useFelaEnhanced } from '@ackee/fela';

import { LocalizedLink } from '../../../ui';

import * as felaRules from './BlogBackLink.rules';

export interface BlogBackLinkProps {
    children?: ReactNode;
    to?: string;
}

export const BlogBackLink = ({ children, to = '/blog' }: BlogBackLinkProps) => {
    const { styles } = useFelaEnhanced(felaRules);

    return (
        <LocalizedLink to={to} className={styles.link}>
            {children || <FormattedMessage id="blog.backToHome" />}
        </LocalizedLink>
    );
};
